//fetchEmployeeFromAdmin

import api from "./api";


export const fetchEmployeeFromAdmin=async(state,district,designation)=>{
      let url = `/api/employee-posting/update-personal-info?stateId=${state}`;
    
    if (district) {
        url += `&districtId=${district}`;
    }

    if (designation) {
        url += `&designationId=${designation}`;
    }
    // Make the API request
    const response =await api.get(url);
    return response.data;

}

export const fetchEmployeeFromSelf=async(employeeId)=>{
    const response = await api.get(`/api/employee-posting/by-employee?employeeId=${employeeId}`);
    return response.data;
    // Make the API request
 

}


export const fetchExistingEmployees=async(state,district,designation)=>{
      let url = `/api/employee-posting/mail-sent?stateId=${state}`;
    
    if (district) {
        url += `&districtId=${district}`;
    }
    
    if (designation) {
        url += `&designationId=${designation}`;
    }
    // Make the API request
    const response =await api.get(url);
    return response.data;

}


export const fetchEmployeeDetails=async(state,district,designation)=>{
      let url = `/api/employee-posting/filter-based-designation?stateId=${state}`;
    
    if (district) {
        url += `&districtId=${district}`;
    }

    if (designation) {
        url += `&designationId=${designation}`;
    }
    // Make the API request
    const response =await api.get(url);
    return response.data;

}